'use strict';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'isomorphic-fetch';
import React from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import AutocompleteItem from './AutocompleteItem';

const API_AUTOCOMPLETE_URL = '/api/places/autocomplete';

class Autocomplete extends React.Component {
  static propTypes = {
    updater: PropTypes.object.isRequired,
    defaultValue: PropTypes.string,
    language: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    data: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.defaultValue,
      data: props.data || [],
    };
  }

  handleClickOutside() {
    this.setState({data: []});
  }

  handleChange = (e) => {
    var value = e.target.value;
    if (value === '') {
      this.setState({data: [], value: value});
    } else {
      this.setState({value: value});
      this.callApiToAutocomplete(value);
    }
  }

  handleItemClick = (value) => {
    this.setState({data: [], value: value});
  }

  callApiToAutocomplete(value) {
    var language = this.props.language;
    fetch(`${API_AUTOCOMPLETE_URL}?city=${value}&language=${language}`)
      .then(
        this.handleResponse.bind(this)
      );
  }

  handleResponse(res) {
    if (res.ok) {
      res.json().then(this.handleData.bind(this));
    }
  }

  handleData(data) {
    this.setState({ data: data.payload });
  }

  render() {
    return (
      <div className="autocomplete-wrap">
        <input
          ref="input"
          className="form-control"
          autoComplete="off"
          type="text"
          name={this.props.name}
          value={this.state.value}
          onChange={this.handleChange} />
        <ul className="autocomplete-menu">{
          this.state.data.map((item, idx) =>
            (<AutocompleteItem
              key={idx}
              placeId={item.place_id}
              text={item.structured_formatting.main_text}
              description={item.description}
              updater={this.props.updater}
              language={this.props.language}
              handleItemClick={this.handleItemClick} />)
          )
        }</ul>
      </div>
    );
  }
}

export default onClickOutside(Autocomplete);
